import React from "react";
import * as S from "./InputFeild.styles";
import { gcBookingReviewScreen, pushCtaOmniEvents } from "../../../shared/config/omni";
import { CTA_TYPE, getActionNameForOmniture } from "../../../shared/utils/omni-utils";
import { CABS_REVIEW_PAGE, MOB_CABS_REVIEW } from "../../../shared/utils/util-constants";
import { CABS_REVIEW_ROUTE, PICKUP_LABEL } from "../../../shared/utils/util-constants";

interface IInputField {
  inputType?: string;
  labelText?: string;
  subLabelText?: string;
  placeholderText?: string;
  defaulText?: string;
  inputWidth?: string;
  inputHeight?: string;
  margin?: string;
  padding?: string;
  onChange?: Function;
  onBlur?: Function;
  value?: string;
  reference?: string;
  styledProps: object;
  autoCompleteProp?: string;
  identifier?: string;
}


const InputField: React.FC<IInputField> = ({
  inputType,
  labelText,
  subLabelText,
  placeholderText,
  defaulText,
  inputWidth,
  inputHeight,
  margin,
  padding,
  onChange,
  onBlur,
  value,
  reference,
  styledProps =  {},
  autoCompleteProp = "on",
  identifier="",
}) => {
  const handleOnFocus = (e) => {
    pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, `${labelText || identifier}`, true), CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
    if(labelText === PICKUP_LABEL){
      e.target.value = "";
    }
  };
  const handleOnBlur = (e) => {
    if(labelText === PICKUP_LABEL){
      e.target.value = value;
    }
    onBlur() || null;
  }
  return (
    <S.FieldCont
      inputWidth={inputWidth}
      inputHeight={inputHeight}
      margin={margin}
      padding={padding}
    >
      {(labelText || subLabelText) && (
        <div className="labelCont">
          {labelText && <label className="lblText">{labelText}</label>}
          {subLabelText && <span className="lblSubText">{subLabelText}</span>}
        </div>
      )}
      <input
        ref={reference}
        className="textInput"
        type={inputType ? inputType : "text"}
        onChange={onChange ? onChange : null}
        defaultValue={defaulText ? defaulText : ""}
        placeholder={placeholderText ? placeholderText : ""}
        onBlur={handleOnBlur}
        value={value}
        style={styledProps}
        autocomplete={autoCompleteProp}
        onFocus={handleOnFocus}
      />
    </S.FieldCont>
  );
};

export default InputField;
